<template>
  <div>
    <header-top></header-top>
    <div class="detail-content">
      <div class="main-width">
        <div class="category-breadcrumb">
          <router-link
            tag="a"
            class="category-breadcrumb-default"
            :to="{name: 'Category', query: {levelOne: '', levelTwo: '', levelThree: '', keyWord: '', selectType: '', brandId: '' }}"
          >全部商品</router-link>
          <span v-for="(item, index) in category">
            <router-link
              tag="a"
              v-if="item.deep == 1"
              class="category-breadcrumb-default"
              :to="{name: 'Category', query: {levelOne: item.id, levelTwo: '', levelThree: '', keyWord: '', selectType: '', brandId: '' }}"
            >{{item.name}}</router-link>
            <router-link
              tag="a"
              v-else-if="item.deep == 2"
              class="category-breadcrumb-default"
              :to="{name: 'Category', query: {levelOne: category[index-1].id, levelTwo: item.id, levelThree: '', keyWord: '', selectType: '', brandId: '' }}"
            >{{item.name}}</router-link>
            <router-link
              tag="a"
              v-else-if="item.deep == 3"
              class="category-breadcrumb-default"
              :to="{name: 'Category', query: {levelOne: category[index-2].id, levelTwo: category[index-1].id, levelThree: item.id, keyWord: '', selectType: '', brandId: '' }}"
            >{{item.name}}</router-link>
          </span>
          <a class="category-breadcrumb-default category-breadcrumb-last">商品详情</a>
        </div>
        <div v-if="!isBlack">
          <div class="detail-goods-info productContent">
            <div class="detail-goods-img">
              <div class="view">
                <div class="swiper-container gallery-top">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="(item, index) in goodsInfo.goodsNavigateList"
                      :class="{'active-nav': index==0}"
                    >
                      <img :src="imgAddress + item.navigateImage" @error="error(1)" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="preview">
                <div class="arrow-left"></div>
                <div class="arrow-right"></div>
                <div class="swiper-container gallery-thumbs">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="(item, index) in goodsInfo.goodsNavigateList"
                      :class="{'active-nav': index==0}"
                    >
                      <img :src="imgAddress + item.navigateImage" @error="error(1)" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="one-dowload">
                <!-- 一键下载商品素材 -->
                <el-button type="text" @click="oneDowload">一键下载商品素材</el-button>
              </div>
            </div>
            <div class="detail-goods-text" style="padding-right: 0;">
              <div class="detail-goods-code">
                商品编码：
                <span>{{goodsInfo.goodsCode}}</span>
              </div>
              <div
                class="detail-goods-title channel-mendian"
                v-if="goodsInfo.channel==1"
              >{{goodsInfo.goodsName}}</div>
              <div
                class="detail-goods-title channel-dianshang"
                v-else-if="goodsInfo.channel==2"
              >{{goodsInfo.goodsName}}</div>
              <div class="detail-goods-title channel-haitao" v-else>{{goodsInfo.goodsName}}</div>
              <!-- <div class="detail-goods-name channel-xiaolaing" @click="goIfdone">
                              累计总销量<span>{{goodsInfo.saleCount}}</span>件
              </div>-->
              <div class="detail-goods-name">
                品牌名称：
                <span style="color:rgba(53,53,53,1);">{{goodsInfo.brandName}}</span>
              </div>
              <div class="detail-goods-name">
                所属分类：
                <span v-for="(item, index) in category">
                  <router-link
                    tag="a"
                    v-if="item.deep == 1"
                    class="category-breadcrumb-default"
                    :to="{name: 'Category', query: {levelOne: item.id, levelTwo: '', levelThree: '', keyWord: '', selectType: '', brandId: '' }}"
                  >{{item.name}}</router-link>
                  <router-link
                    tag="a"
                    v-else-if="item.deep == 2"
                    class="category-breadcrumb-default"
                    :to="{name: 'Category', query: {levelOne: category[index-1].id, levelTwo: item.id, levelThree: '', keyWord: '', selectType: '', brandId: '' }}"
                  >{{item.name}}</router-link>
                  <router-link
                    tag="a"
                    v-else-if="item.deep == 3"
                    class="category-breadcrumb-default"
                    :to="{name: 'Category', query: {levelOne: category[index-2].id, levelTwo: category[index-1].id, levelThree: item.id, keyWord: '', selectType: '', brandId: '' }}"
                  >{{item.name}}</router-link>
                </span>
              </div>
              <div class="detail-goods-price">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="类似专柜价/吊牌价/厂商指导价"
                  placement="top">
                  <span>划线价：</span>
                </el-tooltip>
                <span class="detail-goods-price-num">{{goodsInfo.suggestPrice?'¥'+goodsInfo.suggestPrice/100:''}}</span>
              </div>
              <div class="detail-goods-time" >
                上架时间：
                <span style="color:rgba(53,53,53,1);">
                  <span>{{goodsInfo.onLineTime}}</span>
                  至
                  <span>{{goodsInfo.offLineTime}}</span>
                </span>
              </div>
              <div class="detail-goods-time" style="color:#fea923;" v-if="goodsInfo.openingTime">
                开售时间：
                <span style="color:#fea923;">
                  <span>{{goodsInfo.openingTime}}</span>
                </span>
              </div>
              <div class="detail-goods-btn-default">
                <template v-if="goodsTaxDisplayType==0||goodsTaxDisplayType==2">
                  <span class="bg-color-gray cursor-pointer" v-if="bhskc == true">暂无库存</span>
                  <span
                    class="bg-color-red cursor-pointer"
                    @click="addGoodsAll(0)"
                    v-else-if="!isNoTaxActive"
                  >一键不带票上架</span>
                  <span class="bg-color-gray cursor-pointer" v-else>一键不带票上架</span>
                </template>
                <template v-if="goodsTaxDisplayType==0||goodsTaxDisplayType==1">
                  <span class="bg-color-gray cursor-pointer" v-if="hskc == true">暂无库存</span>
                  <span
                    class="bg-color-orange cursor-pointer"
                    @click="addGoodsAll(1)"
                    v-else-if="!taxActive"
                  >一键带票上架</span>
                  <span class="bg-color-gray cursor-pointer" v-else>一键带票上架</span>
                </template>
                <el-tooltip
                      v-if="true"
                      class="item"
                      effect="dark"
                      content="添加商品报价至报价篮子，可以批量导出商品报价"
                      placement="top"
                      popper-class="custom-width"
                    >
                <span class="cursor-pointer" style="color: #fea923;border: 1px solid #fea923" v-on:click="getPrice">获取报价</span>
                </el-tooltip>
              </div>

              <div class="detail-bottom-info">一键上架：把带票/不带票的所有有效SKU全部拉入货架</div>
            </div>
            <div class="detail-brandInfo" v-if="false">
              <div class="detail-brandInfo-title">
                <span>品牌介绍</span>
              </div>
              <div class="detail-brandInfo-logo">
                <img :src="imgAddress + brand.backgroundImagePath" @error="error(3)" />
                <img :src="imgAddress + brand.logoPath" class="deatil-brand-logo" @error="error(4)" />
              </div>
              <div class="detail-brandInfo-name">
                <span>{{brand.nameEn}}</span>
                <span>{{brand.nameCn}}</span>
              </div>
              <div class="detail-brandInfo-interduce">
                <div>{{brand.descriptions}}</div>
              </div>
              <div class="detail-brandInfo-link">
                <router-link
                  tag="a"
                  :to="{name: 'Category', query: { levelOne: '', levelTwo: '', levelThree: '', keyWord: '', selectType: '', brandId: brand.brandId }}"
                >走进品牌</router-link>
              </div>
            </div>
          </div>
          <div class="detail-allGoods-line"></div>
          <div class="detail-title">
            货品列表
            <span class="inner_box">(带票库存可开发票,不带票无发票)</span>
          </div>
          <div class="price-control" v-if="goodsInfo.whetherPriceControl == 1">
            <span class="price-control-tips">零售控价</span>
            该商品品牌方控价，请不要低于建议售价对外销售，擅自降价将会终止供应链供货！
          </div>

          <div class="detail-table-box" v-if="tableNewInfo.generalPro.length>0">
            <div>
              <div>一件代发</div>
            </div>

            <table class="detail-table-th">
              <tr>
                <th class>规格</th>
                <template v-if="goodsTaxDisplayType==0||goodsTaxDisplayType==2">
                  <th>
                    <div>不带票</div>

                    <div>建议售价</div>
                  </th>

                  <th class>
                    <div>不带票</div>

                    <div>结算价（+基础运费）</div>
                  </th>

                  <th>不带票库存</th>

                  <th>操作</th>
                </template>
                <template v-if="goodsTaxDisplayType==0||goodsTaxDisplayType==1">
                  <th class>
                    <div>带票</div>

                    <div>建议售价</div>
                  </th>

                  <th class>
                    <div>带票</div>

                    <div>结算价（+基础运费）</div>
                  </th>

                  <th>带票库存</th>

                  <th>操作</th>
                </template>
              </tr>

              <tr v-for="(item, index) in tableNewInfo.generalPro">
                <td class="detail-table-firsttd">
                  <img :src="item.imagePath" style="width:45px;height:45px" />

                  <div>{{item.specName}}</div>
                </td>
                <template v-if="goodsTaxDisplayType==0||goodsTaxDisplayType==2">
                  <td
                    class="table-detail-center"
                  >¥{{item.noTaxProductVo?item.noTaxProductVo.salePrice/100:'--'}}</td>

                  <td class="table-detail-center" style="width: 236px;">
                    <template v-if="item.noTaxProductVo">
                      <div>
                        <span>{{item.noTaxProductVo?'¥'+item.noTaxProductVo.settlementPrice/100:'--'}}</span>

                        <span
                          class="table-detail-gray"
                        >(+{{item.noTaxProductVo?item.noTaxProductVo.freight/100:'--'}})</span>
                      </div>

                      <div class="table-detail-area-box">
                        <el-tooltip
                          v-if="item.noTaxProductVo.refuseArea.length>0"
                          class="item"
                          effect="dark"
                          v-bind:content="item.noTaxProductVo.refuseArea2"
                          placement="bottom"
                        >
                          <span class="table-detail-area">不配送区域</span>
                        </el-tooltip>

                        <el-tooltip
                          v-if="item.noTaxProductVo.specialFee.length>0"
                          class="item"
                          effect="dark"
                          v-bind:content="item.noTaxProductVo.specialFee2"
                          placement="bottom"
                        >
                          <span class="table-detail-specialarea">特殊地区运费</span>
                        </el-tooltip>
                      </div>
                    </template>

                    <template v-else>
                      <div>--</div>
                    </template>
                  </td>
                  <td
                    class="table-detail-center"
                  >{{item.noTaxProductVo?item.noTaxProductVo.inventoryNum:'--'}}
                    <div style="color: rgb(88, 191, 106);border-radius: 12px;width: 60px;height: 18px;border: 1px solid;font-size: 12px;margin: 0 auto;" v-if="item.isSelf == 1">自产自销</div>
                  </td>
                  <td class="table-detail-center">
                    <div
                      class="detail-table-button disalbe-button-grey"
                      v-if="!item.noTaxProductVo||item.noTaxProductVo.inventoryNum==0"
                      @click="onAddShelves(1,0,item.productId)"
                    >暂无库存</div>
                    <div
                      class="detail-table-button disalbe-button-grey"
                      v-else-if="item.noTaxProductVo.shelves==1"
                    >已加入货架</div>
                    <div
                      v-else
                      class="detail-table-button"
                      @click="onAddShelves(1,0,item.productId)"
                    >加入货架</div>
                  </td>
                </template>
                <template v-if="goodsTaxDisplayType==0||goodsTaxDisplayType==1">
                  <td>{{item.taxProductVo?'¥'+item.taxProductVo.salePrice/100:'--'}}</td>

                  <td>
                    <template v-if="item.taxProductVo">
                      <div>
                        <span>{{item.taxProductVo?'¥'+item.taxProductVo.settlementPrice/100:'--'}}</span>

                        <span
                          class="table-detail-gray"
                        >(+{{item.taxProductVo?item.taxProductVo.freight/100:'--'}})</span>
                      </div>

                      <div class="table-detail-area-box">
                        <el-tooltip
                          v-if="item.taxProductVo.refuseArea.length>0"
                          class="item"
                          effect="dark"
                          v-bind:content="item.taxProductVo.refuseArea2"
                          placement="bottom"
                        >
                          <span class="table-detail-area">不配送区域</span>
                        </el-tooltip>

                        <el-tooltip
                          v-if="item.taxProductVo.specialFee.length>0"
                          class="item"
                          effect="dark"
                          v-bind:content="item.taxProductVo.specialFee2"
                          placement="bottom"
                        >
                          <span class="table-detail-specialarea">特殊地区运费</span>
                        </el-tooltip>
                      </div>
                    </template>
                    <template v-else>
                      <div>--</div>
                    </template>
                  </td>
                  <td>{{item.taxProductVo?item.taxProductVo.inventoryNum:'--'}}
                    <div style="color: rgb(88, 191, 106);border-radius: 12px;width: 60px;height: 18px;border: 1px solid;font-size: 12px;margin: 0 auto;" v-if="item.isSelf == 1">自产自销</div>
                  </td>
                  <td>
                    <div
                      class="detail-table-button disalbe-button-grey"
                      v-if="!item.taxProductVo||item.taxProductVo.inventoryNum==0"
                      @click="onAddShelves(1,1,item.productId)"
                    >暂无库存</div>
                    <div
                      class="detail-table-button disalbe-button-grey"
                      v-else-if="item.taxProductVo.shelves==1"
                    >已加入货架</div>
                    <div
                      v-else
                      class="detail-table-button"
                      @click="onAddShelves(1,1,item.productId)"
                    >加入货架</div>
                  </td>
                </template>
              </tr>
            </table>
          </div>

          <div
            class="detail-table-box"
            style="margin-top:40px"
            v-if="tableNewInfo.communityPro.length>0"
          >
            <div>
              <div>社群集采</div>
            </div>
            <table class="detail-table-th">
              <tr>
                <th class>规格</th>
                <template v-if="goodsTaxDisplayType==0||goodsTaxDisplayType==2">
                  <th>
                    <div>不带票</div>

                    <div>建议售价</div>
                  </th>

                  <th class>
                    <div>不带票</div>

                    <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;结算价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                  </th>

                  <th>不带票库存</th>

                  <th>操作</th>
                </template>

                <template v-if="goodsTaxDisplayType==0||goodsTaxDisplayType==1">
                  <th class>
                    <div>带票</div>

                    <div>建议售价</div>
                  </th>

                  <th class>
                    <div>带票</div>

                    <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;结算价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                  </th>

                  <th>带票库存</th>

                  <th>操作</th>
                </template>
              </tr>

              <tr v-for="(item, index) in tableNewInfo.communityPro">
                <td class="detail-table-firsttd">
                  <img :src="item.imagePath" style="width:45px;height:45px" />

                  <div>{{item.specName}}</div>
                </td>
                <template v-if="goodsTaxDisplayType==0||goodsTaxDisplayType==2">
                  <td
                    class="table-detail-center"
                  >¥{{item.noTaxProductVo?item.noTaxProductVo.salePrice/100:'--'}}</td>

                  <td class="table-detail-center" style="width: 236px;">
                    <template v-if="item.noTaxProductVo">
                      <div>
                        <span>{{item.noTaxProductVo?'¥'+ item.noTaxProductVo.settlementPrice/100:'--'}}</span>

                        <!--
                        <span style="color:white;">(+{{item.taxProductVo?item.taxProductVo.freight/100:'--'}})</span>-->
                      </div>

                      <div class="table-detail-area-box">
                        <el-tooltip
                          v-if="item.noTaxProductVo.refuseArea.length>0"
                          class="item"
                          effect="dark"
                          v-bind:content="item.noTaxProductVo.refuseArea2"
                          placement="bottom"
                        >
                          <span class="table-detail-area">不配送区域</span>
                        </el-tooltip>

                        <el-tooltip
                          v-if="item.noTaxProductVo.specialFee.length>0"
                          class="item"
                          effect="dark"
                          v-bind:content="item.noTaxProductVo.specialFee2"
                          placement="bottom"
                        >
                          <span class="table-detail-specialarea">特殊地区运费</span>
                        </el-tooltip>
                      </div>
                    </template>

                    <template v-else>
                      <div>--</div>
                    </template>
                  </td>
                  <td
                    class="table-detail-center"
                  >{{item.noTaxProductVo?item.noTaxProductVo.inventoryNum:'--'}}
                    <div style="color: rgb(88, 191, 106);border-radius: 12px;width: 60px;height: 18px;border: 1px solid;font-size: 12px;margin: 0 auto;" v-if="item.isSelf == 1">自产自销</div>
                  </td>
                  <td class="table-detail-center">
                    <div
                      class="detail-table-button disalbe-button-grey"
                      v-if="!item.noTaxProductVo||item.noTaxProductVo.inventoryNum==0"
                      @click="onAddShelves(2,0,item.productId)"
                    >暂无库存</div>
                    <div
                      class="detail-table-button disalbe-button-grey"
                      v-else-if="item.noTaxProductVo.shelves==1"
                    >已加入货架</div>
                    <div
                      v-else
                      class="detail-table-button"
                      @click="onAddShelves(2,0,item.productId)"
                    >加入货架</div>
                  </td>
                </template>

                <template v-if="goodsTaxDisplayType==0||goodsTaxDisplayType==1">
                  <td>{{item.taxProductVo?'¥'+item.taxProductVo.salePrice/100:'--'}}</td>
                  <td>
                    <template v-if="item.taxProductVo">
                      <div>
                        <span>{{item.taxProductVo?'¥'+item.taxProductVo.settlementPrice/100:'--'}}</span>
                        <!--
                        <span style="color:white;">(+{{item.taxProductVo?item.taxProductVo.freight/100:'--'}})</span>-->
                      </div>

                      <div class="table-detail-area-box">
                        <el-tooltip
                          v-if="item.taxProductVo.refuseArea.length>0"
                          class="item"
                          effect="dark"
                          v-bind:content="item.taxProductVo.refuseArea2"
                          placement="bottom"
                        >
                          <span class="table-detail-area">不配送区域</span>
                        </el-tooltip>

                        <el-tooltip
                          v-if="item.taxProductVo.specialFee.length>0"
                          class="item"
                          effect="dark"
                          v-bind:content="item.taxProductVo.specialFee2"
                          placement="bottom"
                        >
                          <span class="table-detail-specialarea">特殊地区运费</span>
                        </el-tooltip>
                      </div>
                    </template>
                    <template v-else>
                      <div>--</div>
                    </template>
                  </td>
                  <td>{{item.taxProductVo?item.taxProductVo.inventoryNum:'--'}}
                    <div style="color: rgb(88, 191, 106);border-radius: 12px;width: 60px;height: 18px;border: 1px solid;font-size: 12px;margin: 0 auto;" v-if="item.isSelf == 1">自产自销</div>
                  </td>
                  <td>
                    <div
                      class="detail-table-button disalbe-button-grey"
                      v-if="!item.taxProductVo||item.taxProductVo.inventoryNum==0"
                      @click="onAddShelves(2,1,item.productId)"
                    >暂无库存</div>
                    <div
                      class="detail-table-button disalbe-button-grey"
                      v-else-if="item.taxProductVo.shelves==1"
                    >已加入货架</div>
                    <div
                      v-else
                      class="detail-table-button"
                      @click="onAddShelves(2,1,item.productId)"
                    >加入货架</div>
                  </td>
                </template>
              </tr>
            </table>
          </div>

          <div class="detail-goods-line"></div>
          <div v-for="item in goodsInfo.goodsDetailList">
            <div class="detail-goods-bimage">
              <img v-bind:src="imgAddress + item.imagePath" @error="error(1)" />
            </div>
          </div>

          <!-- 销量列表 start -->
          <!-- <div v-if="skuSale.salesInfo.length > 0" class="detail-goods-line ifdone" id="ifdone"></div>
          <div v-if="skuSale.salesInfo.length > 0" class="detail-goods-ifdone">
            <el-table
              :data="skuSale.salesInfo"
              stripe
              :border="false"
              class="detail-goods-ifdone"
              style="width: 1279px">
              <el-table-column
                prop="platformName"
                label="采购商">
              </el-table-column>
              <el-table-column
                prop="specName"
                label="商品规格">
              </el-table-column>
              <el-table-column
                prop="quantity"
                label="数量">
              </el-table-column>
              <el-table-column
                prop="transactionTime"
                label="成交时间">
              </el-table-column>
            </el-table>
            <div class="block">
              <el-pagination
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :current-page.sync="skuSale.pageNum"
                :total="skuSale.total"
                :page-size="skuSale.pageSize">
              </el-pagination>
            </div>
          </div>-->
          <!-- 销量列表 end -->
        </div>
        <div v-else class="invisible-message-wrap">
          <div class="invisible-message-box">
            <div class="icon-cry">
              <img src="../assets/img/red_cry.png" alt />
            </div>
            <div class="desc-box" onselectstart="return false">
              <p v-if="isBlackContent==1">抱歉，该商品暂未授权</p>
              <p v-if="isBlackContent==2">抱歉, 该商品已经下架</p>
              <p>还有更多好货可供您挑选</p>
            </div>
            <div class="return-pre-btn" :style="{'background': colorMain}" @click="returnPre">去挑好货</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
    title=""
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose">
    <div style="text-align: center">成功添加商品到“报价篮子”，可以前往“报价篮子”批量导出商品报价！</div>
    <span slot="footer" class="dialog-footer">
      <div class="category-goods-add-default" style="width: 200px;margin: 0 auto;" @click="dialogVisible = false" >我知道了</div>
    </span>
  </el-dialog>
  </div>
</template>
<script>
import headerTop from "../components/Header";
import store from "../store/index.js";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import {
  goodsInfo,
  // productInfo,
  // addShelves,
  getSkuSaleVolume,
  imgAddress,
  DetailLookPicture,
  ExportGoodsDetail,
  goodsDetailIsBlack,
  getMallProductList,
  addNewShelves,
  carAdress,
  addGoodsAppReport
} from "../config/interface.js";
import { toast, imageError } from "../util/tool.js";
import { fetch } from "../config/fetch.js";
import router from "../router/index.js";
import Jquery from "jquery";
import { mapActions } from "vuex";
import axios from "axios";
import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  data() {
    return {
      suggestPrice: 0, //建议售价
      area: null, //省市区
      colorMain: store.state.colorMain,
      goodsInfo: {},
      tableInfo: {},
      tableNewInfo: {
        communityPro: [],
        updateCommunityPro: [], //带票
        generalPro: [],
        updategeneralPro: [] //不带票
      },
      userInfo: null,
      navigateImages: {},
      goodsTaxDisplayType: store.state.goodsTaxDisplayType,
      goodsId: "",
      userId: store.state.userId,
      isNoTaxActive: true,
      taxActive: true,
      imgAddress: imgAddress,
      category: {},
      brand: {},
      hskc: true,
      bhskc: true,
      activityId: "",
      skuSale: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        salesInfo: []
      },
      pictureDetail: {}, //用于存放商品详情图片
      appId: store.state.appId,
      userId: store.state.userId,
      isBlack: 0,
      isBlackContent: 1,
      dialogVisible: false,
    };
  },
  components: {
    headerTop
  },
  created() {
    this.goodsId = this.$route.query.goodsId;
    this.activityId = this.$route.query.activityId;
    this.onSetArea();
  },
  mounted() {},
  methods: {
    getPrice(){
      let _this = this;
      var data = {
        goodsIdList: [this.goodsId],
        appId: this.$store.state.appId,
      };
      fetch(addGoodsAppReport, data).then((res) => {
        _this.dialogVisible = true;
      });
    },
    ...mapActions({ setGoodsCount: "setGoodsCount" }),
    onSetArea() {
      fetch(carAdress, {
        userId: this.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      }).then(res => {
        this.area = res.data;
        this.queryGoodsIsBlack();
      });
    },
    error(num) {
      imageError(num, event);
    },
    //加入
    onAddShelves(appType, hasTax, productId) {
      fetch(addNewShelves, {
        goodsList: [
          {
            appType,
            goodsId: +this.goodsId,
            hasTax,
            productId
          }
        ],
        userId: this.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      }).then(res => {
        //加入成功
        if (res.code == 10000) {
          var str = "上架成功";
          toast(str, 1, false);
          // this.setGoodsCount();
          this.tableInit();
        } else {
          var str = "上架失败";
          toast(str, 2, false);
        }
      });
    },
    queryGoodsIsBlack() {
      this.tableInit();
      this.init();

      this.detailInfo();
      // let data = {
      //   appId: this.appId,
      //   userId: this.userId,
      //   goodsId: this.goodsId
      // };
      // let url = goodsDetailIsBlack;
      // fetch(url, data).then(async res => {
      //   let resultData = res.data;
      //   let isBlack = resultData.isBlack;

      //   await this.tableInit();

      //   if (
      //     isBlack == 0 &&
      //     (this.tableNewInfo.generalPro.length > 0 ||
      //       this.tableNewInfo.communityPro.length > 0)
      //   ) {
      //     this.isBlack = 0;
      //     this.init();
      //     this.skuSaleInit();
      //     this.detailInfo();
      //   } else {
      //     this.isBlack = 1;
      //   }
      // });
    },
    init() {
      var data = {
        userId: this.userId,
        goodsId: this.goodsId,
        activityId: this.activityId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      var url = goodsInfo;
      fetch(url, data).then(res => {
        this.goodsInfo = res.data;
        //商品详情为空的时候,表示商品已经下架,
        if (!this.goodsInfo) {
          this.isBlack = 1;
          //下架
          this.isBlackContent = 2;
        }
        this.brand = res.data.brand;
        var viewSwiper = new Swiper(".view .swiper-container", {
          observer: true,
          onSlideChangeStart: function() {
            updateNavPosition();
          }
        });
        Jquery(".view .arrow-left,.preview .arrow-left").on("click", function(
          e
        ) {
          e.preventDefault();
          if (viewSwiper.activeIndex == 0) {
            viewSwiper.swipeTo(viewSwiper.slides.length - 1, 1000);
            return;
          }
          viewSwiper.slidePrev();
        });
        Jquery(".view .arrow-right,.preview .arrow-right").on("click", function(
          e
        ) {
          e.preventDefault();
          if (viewSwiper.activeIndex == viewSwiper.slides.length - 1) {
            viewSwiper.slideTo(0, 1000);
            return;
          }
          viewSwiper.slideNext();
        });

        var previewSwiper = new Swiper(".preview .swiper-container", {
          visibilityFullFit: true,
          slidesPerView: "auto",
          onlyExternal: true,
          spaceBetween: 10,
          observer: true,
          onClick: function(event) {
            viewSwiper.slideTo(event.clickedIndex);
          }
        });

        function updateNavPosition() {
          Jquery(".preview .active-nav").removeClass("active-nav");
          var activeNav = Jquery(".preview .swiper-slide")
            .eq(viewSwiper.activeIndex)
            .addClass("active-nav");
          if (!activeNav.hasClass("swiper-slide-visible")) {
            if (activeNav.index() > previewSwiper.activeIndex) {
              var thumbsPerNav =
                Math.floor(previewSwiper.width / activeNav.width()) - 1;
              previewSwiper.slideTo(activeNav.index() - thumbsPerNav);
            } else {
              previewSwiper.slideTo(activeNav.index());
            }
          }
        }

        this.goodsInfo.onLineTime = this.goodsInfo.onLineTime.substring(0, 19);
        this.goodsInfo.offLineTime = this.goodsInfo.offLineTime.substring(
          0,
          19
        );
        var arr = [];
        var categoryOne = {
          id: res.data.categoryOneId,
          deep: 1,
          name: res.data.categoryOneName
        };
        var categoryTwo = {
          id: res.data.categoryTwoId,
          deep: 2,
          name: res.data.categoryTwoName
        };
        var categoryThree = {
          id: res.data.categoryThreeId,
          deep: 3,
          name: res.data.categoryThreeName
        };
        arr.push(categoryOne);
        arr.push(categoryTwo);
        arr.push(categoryThree);
        this.category = arr;
      });
    },

    backAllAddress(arr) {
      //统计下省下面有多少市
      let tarr = [];
      for (let z = 0; z < arr.length; z++) {
        let t = arr[z].split("/");

        if (tarr[t[0]]) {
          tarr[t[0]] = tarr[t[0]] + 1;
        } else {
          tarr[t[0]] = 1;
        }
        if(arr[z].split(":")[1]){
          arr[z] = arr[z].split(":")[0] + ':' +arr[z].split(":")[1] / 100;
        }
      }
      this.area.forEach(e => {
        let t = tarr[e["proName"]];
        //let th = 0;
        // if (t) {
        //   th = t.citys.length;
        // }
        if (e.citys.length == t) {
          let freightprice = 0;
          //删除proName;
          for (let d = arr.length - 1; d >= 0; d--) {
            if (arr[d].split("/")[0] == e["proName"]) {
              freightprice = arr[d].split(":")[1];
              arr.splice(d, 1);
            }
          }
          let simplePro = e["proName"];
          simplePro = simplePro.replace(/西藏自治区/g,'西藏');
          simplePro = simplePro.replace(/新疆维吾尔自治区/g,'新疆');
          simplePro = simplePro.replace(/内蒙古自治区/g,'内蒙古');
          simplePro = simplePro.replace(/广西壮族自治区/g,'广西');
          simplePro = simplePro.replace(/宁夏回族自治区/g,'宁夏');
          simplePro = simplePro.replace(/香港特别行政区/g,'香港');
          simplePro = simplePro.replace(/澳门特别行政区/g,'澳门');
          arr.push(
            simplePro +
              "/全部" +
              (freightprice ? ":¥" + freightprice : "")
          );
        }
      });
    },
    async tableInit() {
      var data = {
        userId: this.userId,
        goodsId: this.goodsId,
        activityId: this.activityId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };

      var url = getMallProductList;
      await fetch(url, data).then(res => {
        this.tableInfo = res.data;
        this.tableNewInfo.generalPro = res.data.generalPro;
        this.tableNewInfo.communityPro = res.data.communityPro?res.data.communityPro:[];
        this.taxActive = true;
        this.isNoTaxActive = true;
        var minSuggestFn = pv => {
          if (this.suggestPrice == 0 || pv < this.suggestPrice) {
            this.suggestPrice = pv;
          }
        };
        //需要改造地址
        for (
          let i = 0;
          i <
          (this.tableNewInfo.generalPro
            ? this.tableNewInfo.generalPro.length
            : 0);
          i++
        ) {
          let arr = [];
          let arr2 = [];
          let arr3 = [];
          let arr4 = [];
          if (this.tableNewInfo.generalPro[i]["noTaxProductVo"]) {
            minSuggestFn(
              this.tableNewInfo.generalPro[i]["noTaxProductVo"].salePrice
            );
            for (
              let j = 0;
              j <
              this.tableNewInfo.generalPro[i]["noTaxProductVo"]["refuseArea"]
                .length;
              j++
            ) {
              arr.push(
                this.tableNewInfo.generalPro[i]["noTaxProductVo"]["refuseArea"][
                  j
                ].proName +
                  "/" +
                  this.tableNewInfo.generalPro[i]["noTaxProductVo"][
                    "refuseArea"
                  ][j].cityName
              );
            }

            this.backAllAddress(arr);
            this.tableNewInfo.generalPro[i]["noTaxProductVo"][
              "refuseArea2"
            ] = arr.join(",");
            for (
              let j = 0;
              j <
              this.tableNewInfo.generalPro[i]["noTaxProductVo"]["specialFee"]
                .length;
              j++
            ) {
              arr2.push(
                this.tableNewInfo.generalPro[i]["noTaxProductVo"]["specialFee"][
                  j
                ].proName +
                  "/" +
                  this.tableNewInfo.generalPro[i]["noTaxProductVo"][
                    "specialFee"
                  ][j].cityName +
                  ":" +
                  this.tableNewInfo.generalPro[i]["noTaxProductVo"][
                    "specialFee"
                  ][j].specialFee
              );
            }
            this.backAllAddress(arr2);
            this.tableNewInfo.generalPro[i]["noTaxProductVo"][
              "specialFee2"
            ] = arr2.join(",");
          }
          if (this.tableNewInfo.generalPro[i]["taxProductVo"]) {
            for (
              let j = 0;
              j <
              this.tableNewInfo.generalPro[i]["taxProductVo"]["refuseArea"]
                .length;
              j++
            ) {
              arr3.push(
                this.tableNewInfo.generalPro[i]["taxProductVo"]["refuseArea"][j]
                  .proName +
                  "/" +
                  this.tableNewInfo.generalPro[i]["taxProductVo"]["refuseArea"][
                    j
                  ].cityName
              );
            }
            this.backAllAddress(arr3);
            this.tableNewInfo.generalPro[i]["taxProductVo"][
              "refuseArea2"
            ] = arr3.join(",");
            for (
              let j = 0;
              j <
              this.tableNewInfo.generalPro[i]["taxProductVo"]["specialFee"]
                .length;
              j++
            ) {
              arr4.push(
                this.tableNewInfo.generalPro[i]["taxProductVo"]["specialFee"][j]
                  .proName +
                  "/" +
                  this.tableNewInfo.generalPro[i]["taxProductVo"]["specialFee"][
                    j
                  ].cityName +
                  ":" +
                  this.tableNewInfo.generalPro[i]["taxProductVo"]["specialFee"][
                    j
                  ].specialFee
              );
            }
            this.backAllAddress(arr4);
            this.tableNewInfo.generalPro[i]["taxProductVo"][
              "specialFee2"
            ] = arr4.join(",");
          }
        }

        for (
          let i = 0;
          i <
          (this.tableNewInfo.communityPro
            ? this.tableNewInfo.communityPro.length
            : 0);
          i++
        ) {
          let arr = [];
          let arr2 = [];
          let arr3 = [];
          let arr4 = [];

          if (this.tableNewInfo.communityPro[i]["noTaxProductVo"]) {
            minSuggestFn(
              this.tableNewInfo.communityPro[i]["noTaxProductVo"].salePrice
            );
            for (
              let j = 0;
              j <
              this.tableNewInfo.communityPro[i]["noTaxProductVo"]["refuseArea"]
                .length;
              j++
            ) {
              arr.push(
                this.tableNewInfo.communityPro[i]["noTaxProductVo"][
                  "refuseArea"
                ][j].proName +
                  "/" +
                  this.tableNewInfo.communityPro[i]["noTaxProductVo"][
                    "refuseArea"
                  ][j].cityName
              );
            }
            this.backAllAddress(arr);
            this.tableNewInfo.communityPro[i]["noTaxProductVo"][
              "refuseArea2"
            ] = arr.join(",");
            for (
              let j = 0;
              j <
              this.tableNewInfo.communityPro[i]["noTaxProductVo"]["specialFee"]
                .length;
              j++
            ) {
              arr2.push(
                this.tableNewInfo.communityPro[i]["noTaxProductVo"][
                  "specialFee"
                ][j].proName +
                  "/" +
                  this.tableNewInfo.communityPro[i]["noTaxProductVo"][
                    "specialFee"
                  ][j].cityName +
                  ":" +
                  this.tableNewInfo.generalPro[i]["noTaxProductVo"][
                    "specialFee"
                  ][j].specialFee
              );
            }
            this.backAllAddress(arr2);

            this.tableNewInfo.communityPro[i]["noTaxProductVo"][
              "specialFee2"
            ] = arr2.join(",");
          }
          if (this.tableNewInfo.communityPro[i]["taxProductVo"]) {
            minSuggestFn(
              this.tableNewInfo.communityPro[i]["taxProductVo"].salePrice
            );
            for (
              let j = 0;
              j <
              this.tableNewInfo.communityPro[i]["taxProductVo"]["refuseArea"]
                .length;
              j++
            ) {
              arr3.push(
                this.tableNewInfo.communityPro[i]["taxProductVo"]["refuseArea"][
                  j
                ].proName +
                  "/" +
                  this.tableNewInfo.communityPro[i]["taxProductVo"][
                    "refuseArea"
                  ][j].cityName
              );
            }
            this.backAllAddress(arr3);
            this.tableNewInfo.communityPro[i]["taxProductVo"][
              "refuseArea2"
            ] = arr3.join(",");
            for (
              let j = 0;
              j <
              this.tableNewInfo.communityPro[i]["taxProductVo"]["specialFee"]
                .length;
              j++
            ) {
              arr4.push(
                this.tableNewInfo.communityPro[i]["taxProductVo"]["specialFee"][
                  j
                ].proName +
                  "/" +
                  this.tableNewInfo.communityPro[i]["taxProductVo"][
                    "specialFee"
                  ][j].cityName +
                  ":" +
                  this.tableNewInfo.generalPro[i]["taxProductVo"]["specialFee"][
                    j
                  ].specialFee
              );
            }
            this.backAllAddress(arr4);
            this.tableNewInfo.communityPro[i]["taxProductVo"][
              "specialFee2"
            ] = arr4.join(",");
          }
        }
        this.tableNewInfo.updateCommunityPro = [];
        this.tableNewInfo.updategeneralPro = [];
        //带票和不带票同
        for (let i = 0; i < this.tableNewInfo.generalPro.length; i++) {
          if (this.tableNewInfo.generalPro[i].taxProductVo) {
            minSuggestFn(
              this.tableNewInfo.generalPro[i]["taxProductVo"].salePrice
            );
            if (
              this.tableNewInfo.generalPro[i].taxProductVo.inventoryNum != 0
            ) {
              this.hskc = false;
              this.tableNewInfo.generalPro[i].taxProductVo.appType = 1;
              this.tableNewInfo.updateCommunityPro.push(
                this.tableNewInfo.generalPro[i].taxProductVo
              );
            }
            //已经上架了,1上架,0没有上架
            if (
              this.tableNewInfo.generalPro[i].taxProductVo.shelves != 1 &&
              !(
                !this.tableNewInfo.generalPro[i].taxProductVo ||
                this.tableNewInfo.generalPro[i].taxProductVo.inventoryNum == 0
              )
            ) {
              this.taxActive = false;
            }

            this.tableNewInfo.generalPro[
              i
            ].taxProductVo.productId = this.tableNewInfo.generalPro[
              i
            ].productId;
          }
          if (this.tableNewInfo.generalPro[i].noTaxProductVo) {
            if (
              this.tableNewInfo.generalPro[i].noTaxProductVo.inventoryNum != 0
            ) {
              this.bhskc = false;
              this.tableNewInfo.generalPro[i].noTaxProductVo.appType = 1;
              this.tableNewInfo.updategeneralPro.push(
                this.tableNewInfo.generalPro[i].noTaxProductVo
              );
            }
            //bhskc 为true表示无库存  isNoTaxActive为false表示可以点击
            if (
              this.tableNewInfo.generalPro[i].noTaxProductVo.shelves != 1 &&
              !(
                !this.tableNewInfo.generalPro[i].noTaxProductVo ||
                this.tableNewInfo.generalPro[i].noTaxProductVo.inventoryNum == 0
              )
            ) {
              this.isNoTaxActive = false;
            }

            this.tableNewInfo.generalPro[
              i
            ].noTaxProductVo.productId = this.tableNewInfo.generalPro[
              i
            ].productId;
          }
        }

        for (let i = 0; i < this.tableNewInfo.communityPro.length; i++) {
          if (this.tableNewInfo.communityPro[i].taxProductVo) {
            if (
              this.tableNewInfo.communityPro[i].taxProductVo.inventoryNum != 0
            ) {
              this.hskc = false;
              this.tableNewInfo.communityPro[i].taxProductVo.appType = 2;
              this.tableNewInfo.updateCommunityPro.push(
                this.tableNewInfo.communityPro[i].taxProductVo
              );
            }

            if (
              this.tableNewInfo.communityPro[i].taxProductVo.shelves != 1 &&
              !(
                !this.tableNewInfo.communityPro[i].taxProductVo ||
                this.tableNewInfo.communityPro[i].taxProductVo.inventoryNum == 0
              )
            ) {
              this.taxActive = false;
            }

            this.tableNewInfo.communityPro[
              i
            ].taxProductVo.productId = this.tableNewInfo.communityPro[
              i
            ].productId;
          }
          if (this.tableNewInfo.communityPro[i].noTaxProductVo) {
            if (
              this.tableNewInfo.communityPro[i].noTaxProductVo.inventoryNum != 0
            ) {
              this.bhskc = false;
              this.tableNewInfo.communityPro[i].noTaxProductVo.appType = 2;
              this.tableNewInfo.updategeneralPro.push(
                this.tableNewInfo.communityPro[i].noTaxProductVo
              );
            }

            if (
              this.tableNewInfo.communityPro[i].noTaxProductVo.shelves != 1 &&
              !(
                !this.tableNewInfo.communityPro[i].noTaxProductVo ||
                this.tableNewInfo.communityPro[i].noTaxProductVo.inventoryNum ==
                  0
              )
            ) {
              this.isNoTaxActive = false;
            }

            this.tableNewInfo.communityPro[
              i
            ].noTaxProductVo.productId = this.tableNewInfo.communityPro[
              i
            ].productId;
          }
        }

        // this.navigateImages = res.data.goodsNavigateList;
        // for (var i in this.tableInfo) {
        //   if (
        //     this.tableInfo[i].taxShelves == 0 &&
        //     this.tableInfo[i].taxInventoryNum > 0
        //   ) {
        //     this.taxActive = true;
        //this.hskc = false;
        //   }
        //   if (this.tableInfo[i].taxInventoryNum > 0) {
        //     this.hskc = false;
        //   }
        //   if (
        //     this.tableInfo[i].noTaxShelves == 0 &&
        //     this.tableInfo[i].inventoryNum > 0
        //   ) {
        //     this.isNoTaxActive = true;
        //   }
        //   if (this.tableInfo[i].inventoryNum > 0) {
        //     this.bhskc = false;
        //   }
        // }
      });
    },

    addGoodsAll(num) {
      var goodsList = [];

      //一键不带票
      if (num == 0) {
        this.tableInfo = this.tableNewInfo.updategeneralPro;
        //一键带票
      } else if (num == 1) {
        this.tableInfo = this.tableNewInfo.updateCommunityPro;
      }
      for (var i in this.tableInfo) {
        var goodsItem = {};
        goodsItem.goodsId = +this.goodsId;
        goodsItem.productId = +this.tableInfo[i].productId;
        goodsItem.appType = +this.tableInfo[i].appType; //1,一件代发,2社群集采
        //goodsItem.activityDetailId = tableInfo[i].activityDetailId;
        goodsItem.hasTax = num;
        goodsList.push(goodsItem);
      }
      if (num == 1) {
        this.taxActive = false;
      } else {
        this.isNoTaxActive = false;
      }
      var data = {
        goodsList: goodsList,
        userId: this.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      var url = addNewShelves;
      fetch(url, data).then(res => {
        if (res.code == 10000) {
          var str = "上架成功";
          toast(str, 1, false);
          this.setGoodsCount();
          this.tableInit();
        } else {
          var str = "上架失败";
          toast(str, 2, false);
        }
      });
    },
    addGoods(index, tax, id, activityDetailId) {
      var goodsList = [];
      var goodsitem = {};
      var goodsItem = {};
      var tableInfo = this.tableInfo;
      goodsItem.goodsId = this.goodsId;
      goodsItem.productId = id;
      goodsItem.hasTax = tax;
      goodsItem.activityDetailId = activityDetailId;
      goodsList.push(goodsItem);
      var data = {
        goodsList: goodsList,
        userId: this.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      var url = addShelves;
      fetch(url, data).then(res => {
        if (res.code == 10000) {
          var str = "上架成功";
          toast(str, 1, false);
          this.setGoodsCount();
          this.tableInit();
        } else {
          var str = "上架失败";
          toast(str, 2, false);
        }
      });
    },

    // 商品详情图片
    detailInfo() {
      let url = DetailLookPicture;
      let params = {
        goodsId: this.goodsId,
        userId: this.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      fetch(url, params).then(res => {
        if (res.code == 10000) {
          this.pictureDetail = res.data;
          // let data=res.data;
          // data.detailList.forEach(value,index)
        }
      });
    },
    //一件下载商品素材
    oneDowload() {
      let _this = this;
      let goodsName = _this.goodsInfo.goodsName + ".zip";
      let params = {
        goodsId: this.goodsId,
        userId: this.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      let url1 = ExportGoodsDetail;
      let responseType = "arraybuffer";
      fetch(url1, params, responseType).then(async res => {
        console.log("9的文件11");
        // console.log(res);
        let fileName = res.headers["content-disposition"].substring(
          res.headers["content-disposition"].indexOf("=") + 1
        );
        var zip = new JSZip();
        // 添加excel表格
        zip.file(fileName, res.data, { binary: true }); // 逐个添加文件
        let obj = this.pictureDetail;
        console.log("obj");
        console.log(obj);
        // zip.file("readme.txt", "一件下载运费模板素材\n");
        var detail_img = zip.folder("详情图");
        var detail_imageSuffix = []; //图片后缀
        var detail_imgBase64 = [];
        // 详情图 suffix_item
        for (let i = 0; i < obj.detailList.length; i++) {
          let img_item = obj.detailList[i].imagePath;
          let suffix_item = img_item.substring(img_item.lastIndexOf("."));
          detail_imageSuffix.push(suffix_item);
          let p1 = _this.getBase64(obj.detailList[i].imagePath).then(
            function(base64) {
              detail_imgBase64.push(base64.substring(22));
            },
            function(err) {
              console.log(err); //打印异常信息
            }
          );
          await p1;
        }

        function tt() {
          let length = obj.detailList.length;
          return new Promise(resolve => {
            setTimeout(function() {
              if (length == detail_imgBase64.length) {
                for (var i = 0; i < length; i++) {
                  detail_img.file(
                    "详情图" + (i + 1) + detail_imageSuffix[i],
                    detail_imgBase64[i],
                    {
                      base64: true
                    }
                  );
                }
              } else {
                tt();
              }
              resolve();
            }, 100);
          });
        }

        // 主图
        let main_img = zip.folder("主图");
        var main_imgBase64 = []; //图片的二进制流
        let main_imageSuffix = []; //图片后缀;

        for (let i = 0; i < obj.navigateList.length; i++) {
          let img_item = obj.navigateList[i].imagePath;
          let suffix_item = img_item.substring(img_item.lastIndexOf("."));
          main_imageSuffix.push(suffix_item);
          let p2 = _this.getBase64(obj.navigateList[i].imagePath).then(
            function(base64) {
              main_imgBase64.push(base64.substring(22));
            },
            function(err) {
              console.log(err); //打印异常信息
            }
          );
          await p2;
        }

        function ttOne() {
          let length = obj.navigateList.length;
          return new Promise(resolve => {
            setTimeout(function() {
              if (length == main_imgBase64.length) {
                for (var i = 0; i < length; i++) {
                  main_img.file(
                    "主图" + (i + 1) + main_imageSuffix[i],
                    main_imgBase64[i],
                    {
                      base64: true
                    }
                  );
                }
              } else {
                ttOne();
              }
              resolve();
            }, 100);
          });
        }

        let spec_img = zip.folder("规格图");
        let spec_imgBase64 = []; //图片的二进制流
        let spec_imageSuffix = []; //图片后缀;
        for (let i = 0; i < obj.specList.length; i++) {
          let spec_item = obj.specList[i].imagePath;
          let spec_suffix = spec_item.substring(spec_item.lastIndexOf("."));
          spec_imageSuffix.push(spec_suffix);
          let p3 = _this.getBase64(obj.specList[i].imagePath).then(
            function(base64) {
              spec_imgBase64.push(base64.substring(22));
            },
            function(err) {
              console.log(err); //打印异常信息
            }
          );
          await p3;
        }

        function spec_tt() {
          let length = obj.specList.length;
          return new Promise(resolve => {
            setTimeout(function() {
              if (length == spec_imgBase64.length) {
                for (var i = 0; i < length; i++) {
                  spec_img.file(
                    "规格图" + (i + 1) + spec_imageSuffix,
                    spec_imgBase64[i],
                    {
                      base64: true
                    }
                  );
                }
                // zip.generateAsync({type: "blob"}).then(function (content) {
                //     // see FileSaver.js
                //     saveAs(content, goodsName);
                // });
              } else {
                spec_tt();
              }
              resolve();
            }, 100);
          });
        }

        let p4 = tt();
        let p5 = ttOne();
        let p6 = spec_tt();
        Promise.all([p4, p5, p6]).then(function(results) {
          setTimeout(function() {
            zip.generateAsync({ type: "blob" }).then(function(content) {
              saveAs(content, goodsName);
            });
          }, 2000);
        });
      });
    },
    getBase64(img) {
      let _this = this;

      function getBase64Image(img, width, height) {
        //width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
        var canvas = document.createElement("canvas");
        canvas.width = width ? width : img.width;
        canvas.height = height ? height : img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        var dataURL = canvas.toDataURL();
        return dataURL;
      }
      var image = new Image();
      image.crossOrigin = "Anonymous";
      image.src = img;
      var deferred = Jquery.Deferred();
      if (img) {
        image.onload = function() {
          deferred.resolve(getBase64Image(image)); //将base64传给done上传处理
        };
        return deferred.promise(); //问题要让onload完成后再return sessionStorage['imgTest']
      }
    },
    returnPre() {
      this.$router.replace("index/home");
      //this.$router.go(-2); //返回上一页
    }
  }
};
</script>
<style lang="less" scoped>
.disalbe-button-grey {
  pointer-events: none;
  width: 82px;
  height: 31px;
  background: rgba(192, 192, 192, 1) !important;
}
.detail-bottom-info::before {
  display: inline-block;
  content: "";
  width: 14px;
  margin-right: 5px;
  height: 14px;
  background: url("../assets/img/detail-grey-info.png") no-repeat center
    center/100% 100%;
}
.detail-bottom-info {
  display: flex;

  align-items: center;
  margin-top: 20px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.detail-table-firsttd {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
}

.detail-table-th {
  th {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
  }
}

.table-detail-gray {
  color: #999999;
}

.table-detail-center {
  text-align: center;
}

.table-detail-area-box {
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
}

.table-detail-area {
  cursor: pointer;
  margin-top: 4px;
  height: 20px;
  background: rgba(247, 247, 247, 1);
  border-radius: 11px;
  border: 1px solid rgba(229, 229, 229, 1);
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
  padding: 0 5px;
}

.table-detail-specialarea {
  cursor: pointer;
  margin-top: 4px;
  margin-left: 10px;
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
  padding: 0 5px;
  height: 20px;
  background: rgba(247, 247, 247, 1);
  border-radius: 11px;
  border: 1px solid rgba(229, 229, 229, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.detail-table-button {
  cursor: pointer;
  width: 82px;
  height: 31px;
  margin: 0 auto;
  background: rgba(254, 169, 35, 1);
  font-size: 14px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detail-table-box {
  display: flex;
  th {
    height: 65px;
    background: rgba(242, 242, 242, 1);
  }
  th:nth-child(1),
  th:nth-child(5) {
    border-right: 1px solid rgba(229, 229, 229, 1);
  }
  td {
    height: 60px;
    background: #fafafa;
    text-align: center;
  }
  td:nth-child(1),
  td:nth-child(5) {
    border-right: 1px solid rgba(229, 229, 229, 1);
  }
  table {
    flex: 1;
    border-spacing: 0 !important;
  }
  flex-direction: row;
  > div:nth-child(1) {
    > div:nth-child(1) {
      width: 16px;
      margin: 0 auto;
      font-size: 16px;
      font-family: PingFangSC;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
      position: absolute;
    }
    width: 50px;
    margin: 0 10px 0 10px;
    position: relative; // height: 335px;
    background: rgba(247, 141, 76, 1);

    box-shadow: 2px 2px 10px 0px rgba(193, 134, 97, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    word-wrap: break-word;
  }
}

.detail-title {
  height: 33px;
  font-size: 24px;
  font-family: PingFangSC;
  font-weight: bold;
  margin-bottom: 20px;
  margin-left: 10px;
  color: rgba(51, 51, 51, 1);
  line-height: 33px;
  > span {
    font-weight: normal;
    color: #999999;
    font-size: 16px;
  }
}

.swiper-container {
  width: 400px;
  height: 400px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.gallery-top {
  height: 400px;
  width: 400px;
}

.gallery-top .swiper-slide {
  border: 0 !important;
}

.gallery-top .swiper-slide img {
  width: 400px;
  height: 400px;
}

.preview {
  width: 100%;
  position: relative;
  margin-top: 23px;
}

.preview .swiper-container {
  width: 330px;
  height: 72px;
  margin-left: 35px;
}

.preview .swiper-slide {
  width: 82px;
  height: 72px;
}

.preview img {
  padding: 1px;
  height: 70px;
  width: 70px;
}

.preview .active-nav img {
  padding: 0;
  border: 1px solid #fea923;
}

.one-dowload {
  position: relative;
  /* border:1px solid red; */
  color: #409eff !important;
  text-align: center;
  /* font-size:12px; */
  margin-top: 10px;
  /* border: 1px solid red; */
}

.one-dowload::after {
  position: absolute;
  width: 110px;
  height: 1px;
  background-color: #22ab39;
  top: 29px;
  left: 50%;
  margin-left: -43px;
  content: "";
  display: block;
}
.one-dowload .el-button--text::before {
  display: inline-block;
  content: "";
  width: 16px;
  margin-right: 6px;
  vertical-align: middle;
  height: 14px;
  background: url("../assets/img/loadpic.png") no-repeat center center/100% 100%;
}

.one-dowload .el-button--text {
  color: #22ab39 !important;
}

.invisible-message-wrap {
  position: relative;
  width: 100%;
  height: auto;
  padding: 159px 0 325px;
}

.invisible-message-box {
  width: 400px;
  padding: 42px 0;
  margin: 0 auto;
  border-radius: 4px;
}

.invisible-message-wrap .icon-cry {
  width: 120px;
  height: 120px;
  margin: 0 auto 22px;
}

.invisible-message-wrap .icon-cry img {
  width: 100%;
  height: 100%;
}

.invisible-message-wrap .desc-box {
  font-size: 22px;
  line-height: 28px;
  color: #333;
  text-align: center;
  letter-spacing: 1px;
}

.invisible-message-wrap .desc-box p:last-child {
  font-size: 18px;
  color: #666;
}

.invisible-message-box .return-pre-btn {
  width: 250px;
  height: 50px;
  margin: 100px auto 0;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  letter-spacing: 1px;
  cursor: pointer;
}
.price-control{
  color: #F56C6C;
  font-size: 12px;
  margin-top: -20px;
  margin-bottom: 20px;
  padding: 0 10px;
  box-sizing: border-box;
  .price-control-tips{
    background-color: #F56C6C;
    color: #fff;
    font-size: 10px;
    border-radius: 12px;
    padding: 0 6px;
    box-sizing: border-box;
  }
}
</style>
<style>
  .custom-width{
    width: 300px
  }
</style>



// WEBPACK FOOTER //
// Detail.vue?383f1835